import { createEvent, restore, sample } from 'effector'
import { PromoCodeResponse, PromoCodeRequest, PromoCode } from './types'
import { fx } from '../../../../libs'
import {
  changedDateFormat,
  isAllElementsOfSearchTextNotExist,
} from '../../../../libs/utils'

const DATE_FIELDS = ['expiresAt', 'addedAt']

const mapSearchEntry = (key: string, value: any): [string, any] => {
  if (DATE_FIELDS.includes(key)) {
    const dates = Array.isArray(value)
      ? value.map((date) => (date ? changedDateFormat(date?.$d) : `${date}`))
      : value
    return [key, dates]
  }

  return [key, value?.toLowerCase()]
}

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map(([key, value]) =>
      mapSearchEntry(key, value),
    ),
  )
}

export const promoCodeListMounted = createEvent<PromoCodeRequest>()

export const getPromoCodeList = fx<PromoCodeRequest, PromoCodeResponse>({
  method: 'GET',
  url: `/deposit_bonus/promo_code`,
})

export const $promoCodeList = restore<PromoCode[]>(
  getPromoCodeList.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfPromoCodeList = restore(
  getPromoCodeList.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: promoCodeListMounted,
  fn: ({ searchText, limit, page, orderBy, orderDirection, filters }) => {
    let newObj = {}

    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (!isAllElementsOfSearchTextNotExist(searchText)) {
      newObj = { ...newObj, ...mapSearchText(searchText) }
    }

    // @ts-ignore
    if (filters?.disabledAt?.length > 0) {
      // @ts-ignore
      const value = filters.disabledAt[0]
      if (value === 'null') {
        // @ts-ignore
        newObj['disabledAt'] = 'null'
      } else if (value === 'not null') {
        // @ts-ignore
        newObj['disabledAt'] = 'not null'
      }
    } else {
      // @ts-ignore
      newObj['disabledAt'] = 'null'
    }

    // @ts-ignore
    query['where'] = `${JSON.stringify(newObj)}`

    // @ts-ignore
    query['populate'] = JSON.stringify(['PromoCode.createdBy'])

    return {
      query,
    }
  },
  target: getPromoCodeList,
})
